export enum EntityStoreKey {
  TellentRoles = 'TellentRoles',
}
